export default {"src":"/_next/static/media/logo.58b2f326.svg","height":256,"width":256};